<template>
  <div class="income" ref="refDialog">
    <div class="income-dialog">
      <div class="income-dialog-header" ref="refDialogHeader">
        <div class="income-dialog-header-wrapper" v-if="initData.onRingingParams.clid">
          <span>外显号码：</span>
          <span>{{ initData.onRingingParams.clid || "010-59567410"}}</span>
        </div>
      </div>
      <div class="income-dialog-body">
        <div class="income-text" v-if="initData.convId">{{ initData.convId }}</div>
        <div class="income-time">
          <span class="income-time-left">{{ initData.customerIncomingDetails.phone }}  <br><i style="font-style: normal; font-size: 14px;">该号码进线{{initData.callInCount}}次</i></span>
          <span class="income-time-right">{{ formatSeconds(initData.currentTime) }}</span>
        </div>
        <div class="income-status">
          <div v-if="initData.callWindowStatus === 'ON_RING'">正在振铃中</div>
          <div v-if="initData.callWindowStatus === 'ON_FORWARDING'">AI转接中</div>
          <div v-if="initData.callWindowStatus === 'ON_CALLING'">正在通话中</div>
          <div>
            <span class="income-phone-copy" @click="copy(initData.customerIncomingDetails.phone)">复制来电号码</span>
          </div>
        </div>
        <div class="income-btns">
          <template v-if="lusUserCti.type !== 'RGYB'">
            <el-button class="un-mute" v-if="initData.muting" @click="initData.unMute">取消保持</el-button>
            <el-button class="mute" v-else @click="initData.mute">保持</el-button>
          </template>
          <el-button v-if="isCallOut && callWindowStatus === 'ON_CALLING'" class="score" @click="$emit('onRatingHangupe')">评分</el-button>
          <el-button class="hangup" @click="initData.hangup">挂断</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {Message} from 'element-ui';
import DragModalHeader from '@/components/mixins/DragModalHeader2';
import {copyText} from '@/utils/base';
import {formatSeconds} from '@/utils/timedate';

export default {
  mixins: [DragModalHeader],
  props: {
    initData: Object,
    isCallOut: {type: Boolean, default: false},
    callWindowStatus: String,
  },
  computed: {
    ...mapState('global', ['lusUserCti']),
  },
  methods: {
    formatSeconds(second){
      if (!(second >= 0)) return '';
      return formatSeconds(second * 1000, {
        showLevel: 1,
        isPadZero: true,
      })
    },
    copy(text=''){
      copyText(text);
      Message.success('复制成功！');
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss">

</style>
